import { useUtils as useI18nUtils } from '@core/libs/i18n'
import { useUtils as useAclUtils } from '@core/libs/acl'
import { AccountAccessManager } from '@/utils/accessManager/accessManager'

const { t } = useI18nUtils()
const { canViewVerticalNavMenuHeader } = useAclUtils()

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  render(h) {
    const span = h('span', {}, t(this.item.header))
    const icon = h('feather-icon', { props: { icon: 'MoreHorizontalIcon', size: '18' } })
    if (!AccountAccessManager.canSeeAccountStatistics() && this.item.header === 'ClientPortal.SideMenu.Adsmanager') {
      return h()
    }
    if (!AccountAccessManager.canManageProperties() && this.item.header === 'ClientPortal.SideMenu.Properties') {
      return h()
    }

    if (canViewVerticalNavMenuHeader(this.item)) {
      return h('li', { class: 'navigation-header text-truncate mt-2' }, [span, icon])
    }
    return h()
  },
}
